import classNames from 'classnames';
import React from 'react';
import { TaskLogsType } from '@redux/tasks/tasksTypes';
import { CircleIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { getFormatedTime } from 'utils/time';
import style from './TaskLogs.scss';

type Props = { logsList?: TaskLogsType[] | null };

const formatLogCreated = (value?: string) => {
  if (!value) return '';
  if (value.includes('T') && value.length >= 19) {
    return getFormatedTime(value);
  }
  return value;
};

export const TaskLogs: React.FC<Props> = ({ logsList }) => {
  const logs = logsList ?? [];

  return (
    <div className={style.container}>
      <Text variant="md" weight={600}>
        Task log
      </Text>
      <div className={style.logsContainer}>
        {!logs.length ? (
          <Text variant="sm" color={Color.GRAY}>
            No log entries yet.
          </Text>
        ) : (
          logs.map((log, index, array) => (
            <div className={style.logContainer} key={log.id ?? index}>
              <div className={style.decoration}>
                <CircleIcon width={20} height={20} />
                <div className={style.lineWrapper}>
                  <div className={style.line} />
                </div>
              </div>
              <div className={classNames(style.log, index === array.length - 1 && style.lastLog)}>
                <Text variant="md">{log.logTitle}</Text>
                <Text variant="sm" color={Color.GRAY}>
                  {formatLogCreated(log.logCreated)}
                </Text>
                {log.logMessage && (
                  <div className={style.messageWrapper}>
                    <Text variant="md">{log.logMessage}</Text>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
